import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class LayoutService {
    // Mobile: Controls if sidebar is visible (overlay)
    isMobileSidebarOpen = signal(false);

    // Desktop: Controls if sidebar is collapsed (mini) or expanded
    isDesktopSidebarCollapsed = signal(false);

    /**
     * Toggle mobile sidebar visibility
     */
    toggleMobileSidebar() {
        this.isMobileSidebarOpen.update(v => !v);
    }

    /**
     * Close mobile sidebar (e.g. on navigation)
     */
    closeMobileSidebar() {
        this.isMobileSidebarOpen.set(false);
    }

    /**
     * Toggle desktop sidebar collapse state
     */
    toggleDesktopCollapse() {
        this.isDesktopSidebarCollapsed.update(v => !v);
    }
}
